"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaystePartnerReceivablePayload = exports.WaystePartnerReceivableTransport = exports.WaystePartnerReceivableActionTypeLabels = exports.WaystePartnerReceivableActionType = exports.WaystePartnerReceivableActionTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const line_item_transport_1 = require("./line-item-transport");
const receivable_transport_1 = require("./receivable-transport");
exports.WaystePartnerReceivableActionTypes = ['SUBMIT', 'ADD_CHARGE', 'DISPUTE', 'RESET'];
exports.WaystePartnerReceivableActionType = typebox_1.Type.Union(exports.WaystePartnerReceivableActionTypes.map((action) => typebox_1.Type.Literal(action)));
/**
 * Object mapping actions to their corresponding labels.
 */
exports.WaystePartnerReceivableActionTypeLabels = {
    SUBMIT: 'Submit',
    ADD_CHARGE: 'Add a charge',
    DISPUTE: 'Dispute the receivable',
    RESET: 'Reset the receivable',
};
exports.WaystePartnerReceivableTransport = typebox_1.Type.Object({
    action: exports.WaystePartnerReceivableActionType,
    receivable: receivable_transport_1.WaysteReceivableTransport,
});
const WaystePartnerReceivableSubmitPayload = typebox_1.Type.Object({
    action: typebox_1.Type.Literal('SUBMIT'),
    overageLineItem: typebox_1.Type.Optional(line_item_transport_1.LineItemInputTransport),
    memo: typebox_1.Type.Optional(typebox_1.Type.String()),
});
const WaystePartnerReceivableAddChargePayload = typebox_1.Type.Object({
    action: typebox_1.Type.Literal('ADD_CHARGE'),
    overageLineItem: typebox_1.Type.Optional(line_item_transport_1.LineItemInputTransport),
    memo: typebox_1.Type.Optional(typebox_1.Type.String()),
    newLineItems: typebox_1.Type.Array(line_item_transport_1.LineItemTransport),
});
const WaystePartnerReceivableDisputePayload = typebox_1.Type.Object({
    action: typebox_1.Type.Literal('DISPUTE'),
    overageLineItem: typebox_1.Type.Optional(line_item_transport_1.LineItemInputTransport),
    memo: typebox_1.Type.Optional(typebox_1.Type.String()),
    pointOfContact: typebox_1.Type.Optional(typebox_1.Type.String()),
    note: typebox_1.Type.String(),
});
const WaystePartnerReceivableResetPayload = typebox_1.Type.Object({
    action: typebox_1.Type.Literal('RESET'),
});
exports.WaystePartnerReceivablePayload = typebox_1.Type.Union([
    WaystePartnerReceivableSubmitPayload,
    WaystePartnerReceivableAddChargePayload,
    WaystePartnerReceivableDisputePayload,
    WaystePartnerReceivableResetPayload,
]);
//# sourceMappingURL=wayste-partner-receivable.js.map